import { render, staticRenderFns } from "./VincularTecnicosComponent.vue?vue&type=template&id=2ebe315c&scoped=true"
import script from "./VincularTecnicosComponent.vue?vue&type=script&lang=js"
export * from "./VincularTecnicosComponent.vue?vue&type=script&lang=js"
import style0 from "./VincularTecnicosComponent.vue?vue&type=style&index=0&id=2ebe315c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe315c",
  null
  
)

export default component.exports